import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.promise.finally.js";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spreadArray = this && this.__spreadArray || function (to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) {
    to[j] = from[i];
  }

  return to;
};

import { VoidUrl } from "../common/types";
import { FHTChatId } from "../common/FHTChatId";
import { isUserClientId, getUserIdFromClientId } from "@/common/clientIdUtils";
import { assert } from "@/common/assert";
import { getAuthHash } from "@/pages/base/base";
import { UrlHelperExtensions } from "@/url_helpers";
import { isApiErrorResponse, isExceptionViewModel } from "@/common/apiError";
import { cmsHomeUrl } from "@/urls";
import { PersonalChatApiApi } from "@/apis/api/PersonalChatApiApi";
import { TouristChatApiApi } from "@/apis/api/TouristChatApiApi";
import { UserApiApi } from "@/apis/api/UserApiApi";

var Contact =
/** @class */
function () {
  function Contact(clientId, conversationId, chatId, user, tourist) {
    this.clientId = clientId;
    this.convId = conversationId; //与对方的conversationId

    assert(chatId, "chatId falsy");
    assert(chatId instanceof FHTChatId, "invalid chatId");
    this.chatId = chatId;
    assert(Boolean(user) !== Boolean(tourist), "can only pass either user or tourist, but not both");

    if (user) {
      this.user = user.user;
      this.isFriend = user.isFriend;
    } else {
      this.tourist = tourist;
    }

    this.scrollTop = undefined;
    this.messageIds = [];
    this.lastUpdated = new Date("1995-12-17T03:24:00");
    this.unreadMessageCount = 0;
    this.messageHistoryInfo = {
      hasMoreMessages: true,
      loadedMessageCount: 0,
      earliestHistoryTimestamp: undefined
    };
  }

  Contact.prototype.clone = function () {
    var copy;

    if (this.tourist) {
      copy = new Contact(this.clientId, this.convId, this.chatId, undefined, this.tourist);
    } else {
      copy = new Contact(this.clientId, this.convId, this.chatId, {
        user: this.user,
        isFriend: !!this.isFriend
      });
    }

    copy.scrollTop = this.scrollTop;
    copy.messageIds = __spreadArray([], __read(this.messageIds));
    copy.lastUpdated = this.lastUpdated;
    copy.messageHistoryInfo = __assign({}, this.messageHistoryInfo);
    copy.unreadMessageCount = this.unreadMessageCount;
    return copy;
  };

  Contact.prototype.getContactInfoForTourist = function () {
    var t = this.tourist;
    assert(t, "tourist falsy!");
    return {
      avatarUrl: t.AvatarUrl.AbsoluteUrl,
      name: t.Alias || "游客",
      linkUrl: VoidUrl,
      companyUrl: VoidUrl
    };
  };

  Contact.prototype.getContactInfoForUser = function () {
    var u = this.user.User.User;
    return {
      avatarUrl: u.AvatarUrl.AbsoluteUrl,
      linkUrl: UrlHelperExtensions.$ProfileUrl(u.UserId, {
        stat_ctx: "ChatList"
      }),
      companyId: u.CompanyId,
      companyUrl: u.CompanyId ? cmsHomeUrl(u.CompanyId, {
        stat_ctx: "ChatRoom"
      }) : VoidUrl,
      companyName: u.CompanyName,
      profession: u.Profession,
      name: u.RealName
    };
  };

  Contact.prototype.getContactInfo = function () {
    return this.tourist ? this.getContactInfoForTourist() : this.getContactInfoForUser();
  };

  Contact.fromUserAndPersonalChat = function (user, personalChat) {
    var u = user.User;
    var isFriend = false; //TODO how to get isFriend???

    return new Contact(u.User.ClientId, personalChat.ConversationId, FHTChatId.fromPersonalChat(personalChat.PersonalChatId), {
      user: user,
      isFriend: isFriend
    });
  };

  Contact.fromUserAndTouristChat = function (user, touristChat) {
    var u = user.User;
    var isFriend = false; //TODO how to get isFriend???

    return new Contact(u.User.ClientId, touristChat.ConversationId, FHTChatId.fromTouristChat(touristChat.TouristChatId), {
      user: user,
      isFriend: isFriend
    });
  };

  Contact.fromTourist = function (touristChat) {
    return new Contact(touristChat.TouristId, touristChat.ConversationId, FHTChatId.fromTouristChat(touristChat.TouristChatId), undefined, touristChat);
  };

  Contact._getContactByClientId = function (clientId, myself) {
    return __awaiter(this, void 0, Promise, function () {
      var otherUserId, personalChatApi, userApi, pc, user, touristApi, userApi, tc, user, touristApi, tc, err_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            assert(clientId, "clientId is falsy");
            _a.label = 1;

          case 1:
            _a.trys.push([1, 12,, 13]);

            if (!isUserClientId(clientId)) return [3
            /*break*/
            , 8];
            otherUserId = getUserIdFromClientId(clientId);
            if (!myself.userId) return [3
            /*break*/
            , 4]; //情况1: 对方是用户, 我也是用户

            if (clientId === myself.clientId) {
              throw new Error("不能和您自己聊天哦！");
            }

            personalChatApi = new PersonalChatApiApi();
            userApi = new UserApiApi();
            return [4
            /*yield*/
            , personalChatApi.personalChatApiGetPersonalChatByOtherUser({
              "hash.authHash": getAuthHash(),
              otherUserClientId: clientId
            })];

          case 2:
            pc = _a.sent();
            return [4
            /*yield*/
            , userApi.userApiUserDetail({
              userId: pc.OtherUserId
            })];

          case 3:
            user = _a.sent();
            return [2
            /*return*/
            , Contact.fromUserAndPersonalChat(user, pc)];

          case 4:
            touristApi = new TouristChatApiApi();
            userApi = new UserApiApi();
            return [4
            /*yield*/
            , touristApi.touristChatApiGetForTourist({
              "model.authHash": getAuthHash(),
              otherUserClientId: clientId,
              touristClientId: myself.clientId
            })];

          case 5:
            tc = _a.sent();
            return [4
            /*yield*/
            , userApi.userApiUserDetail({
              userId: otherUserId
            })];

          case 6:
            user = _a.sent();
            return [2
            /*return*/
            , Contact.fromUserAndTouristChat(user, tc)];

          case 7:
            return [3
            /*break*/
            , 11];

          case 8:
            if (!myself.userId) return [3
            /*break*/
            , 10];
            touristApi = new TouristChatApiApi();
            return [4
            /*yield*/
            , touristApi.touristChatApiGetByTouristClientId({
              "model.authHash": getAuthHash(),
              touristClientId: clientId
            })];

          case 9:
            tc = _a.sent();
            return [2
            /*return*/
            , Contact.fromTourist(tc)];

          case 10:
            //情况4: 对方是游客，我也是游客
            throw new Error("游客之间不能聊天");

          case 11:
            return [3
            /*break*/
            , 13];

          case 12:
            err_1 = _a.sent();

            if (isApiErrorResponse(err_1)) {
              return [2
              /*return*/
              , err_1.responseJSON];
            } else {
              throw err_1;
            }

            return [3
            /*break*/
            , 13];

          case 13:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  Contact.getContactByClientId = function (clientId, myself) {
    return __awaiter(this, void 0, Promise, function () {
      var c;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this._getContactByClientId(clientId, myself)];

          case 1:
            c = _a.sent();

            if (isExceptionViewModel(c)) {
              return [2
              /*return*/
              , c];
            } else {
              assert(c.convId, "c.convId falsy");
              assert(c.chatId.encode(), "c.chatId falsy");
              return [2
              /*return*/
              , c];
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  Contact._getContactByFHTChatId = function (chatId, myself) {
    return __awaiter(this, void 0, Promise, function () {
      var userApi, personalChatApi, personalChat, user, touristApi, tc, userApi, user;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            assert(chatId, "chatId is falsy");
            if (!(chatId.chatType === "Personal")) return [3
            /*break*/
            , 5];
            if (!myself.userId) return [3
            /*break*/
            , 3];
            userApi = new UserApiApi();
            personalChatApi = new PersonalChatApiApi();
            return [4
            /*yield*/
            , personalChatApi.personalChatApiGetPersonalChatById({
              "hash.authHash": getAuthHash(),
              personalChatId: chatId.chatServerId
            })];

          case 1:
            personalChat = _a.sent();
            return [4
            /*yield*/
            , userApi.userApiUserDetail({
              userId: personalChat.OtherUserId
            })];

          case 2:
            user = _a.sent();
            return [2
            /*return*/
            , this.fromUserAndPersonalChat(user, personalChat)];

          case 3:
            throw new Error("Impossible to reach here");

          case 4:
            return [3
            /*break*/
            , 11];

          case 5:
            if (!(chatId && chatId.chatType === "Tourist")) return [3
            /*break*/
            , 10];
            touristApi = new TouristChatApiApi();
            return [4
            /*yield*/
            , touristApi.touristChatApiGet({
              touristChatId: chatId.chatServerId,
              touristClientId: myself.clientId
            })];

          case 6:
            tc = _a.sent();
            if (!myself.userId) return [3
            /*break*/
            , 7];
            return [2
            /*return*/
            , this.fromTourist(tc)];

          case 7:
            userApi = new UserApiApi();
            return [4
            /*yield*/
            , userApi.userApiUserDetail({
              userId: tc.UserId
            })];

          case 8:
            user = _a.sent();
            return [2
            /*return*/
            , this.fromUserAndTouristChat(user, tc)];

          case 9:
            return [3
            /*break*/
            , 11];

          case 10:
            throw new Error("ignore conv of type:" + (chatId === null || chatId === void 0 ? void 0 : chatId.chatType));

          case 11:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  Contact.isContact = function (contact) {
    var isInstance = contact instanceof Contact;
    if (isInstance) return true;
    var maybeContact = contact;

    if (maybeContact) {
      //see if is very likely a Contact;
      var veryLikely = maybeContact.chatId && maybeContact.clientId;

      if (veryLikely) {
        console.warn("Please ensure contact is a real instanceof Contact");
        return true;
      }
    }

    return false;
  };

  Contact.getContactByFHTChatId = function (chatId, myself) {
    return __awaiter(this, void 0, Promise, function () {
      var p, inflightKey;

      var _this = this;

      return __generator(this, function (_a) {
        inflightKey = chatId.encode(); // @ts-ignore

        if (this._inFlightContacts[inflightKey]) {
          p = this._inFlightContacts[inflightKey];
        } else {
          p = this._getContactByFHTChatId(chatId, myself);
          this._inFlightContacts[inflightKey] = p;
        }

        p["finally"](function () {
          return delete _this._inFlightContacts[inflightKey];
        });
        return [2
        /*return*/
        , p];
      });
    });
  };

  Contact._inFlightContacts = {};
  return Contact;
}();

export { Contact };